import React from "react";
import { Reveal, Eyebrow } from "./MarketingUI";
import { FileSpreadsheet, Mail, FolderOpen, Database, ArrowRight } from "lucide-react";

const fragments = [
  { icon: FileSpreadsheet, label: "Spreadsheets" },
  { icon: Mail, label: "Inboxes" },
  { icon: FolderOpen, label: "Shared drives" },
  { icon: Database, label: "Disconnected systems" },
];

export default function Problem() {
  return (
    <section id="platform" className="bg-[#F5F7FA] py-24 sm:py-28" data-testid="problem-section">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <Reveal><Eyebrow>The problem</Eyebrow></Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-4 max-w-4xl font-display text-3xl font-extrabold leading-tight tracking-tight text-brand-ink sm:text-4xl">
            Legislative work shouldn&apos;t live across spreadsheets, inboxes, shared drives, and disconnected systems.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-brand-slate">
            When the record is scattered, so is the response. GovFlowState centralizes legislative activity and the internal work surrounding it — so every action lives in one place.
          </p>
        </Reveal>

        <div className="mt-14 flex flex-col items-center gap-8 lg:flex-row lg:justify-between">
          <div className="grid w-full grid-cols-2 gap-3 lg:max-w-md">
            {fragments.map((f, i) => (
              <Reveal key={f.label} delay={0.08 * i}>
                <div className="flex items-center gap-3 rounded-xl border border-dashed border-brand-line-strong bg-white/70 px-4 py-4 text-brand-slate" data-testid={`problem-fragment-${i}`}>
                  <f.icon className="h-5 w-5 text-slate-400" />
                  <span className="text-sm font-medium">{f.label}</span>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.2} className="hidden shrink-0 lg:block">
            <ArrowRight className="h-8 w-8 text-brand-civic" />
          </Reveal>

          <Reveal delay={0.24} className="w-full lg:max-w-xs">
            <div className="rounded-2xl border border-brand-line bg-brand-navy p-7 text-center shadow-elevated" data-testid="problem-converged">
              <img src="/govflow-mark.png" alt="" className="mx-auto h-10 w-10 object-contain" />
              <p className="mt-4 font-display text-lg font-bold text-white">One legislative picture</p>
              <p className="mt-1 text-sm text-white/60">Every bill, action, and assignment, converged.</p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
